<template>
  <div>
    <div class="card bg-white shadow-lg card-frame card-bordered" :class="{ 'border-danger': item.mortgage.DaysRemaining === 30 }">
      <div class="card-header">
        <div class="font-size-2 font-weight-bold" style="overflow: hidden;" @click="$emit('edit')">
          {{ item.Description }}
        </div>
        <div class="float-right">
          <div class="btn-group">
            <button type="button" :disabled="editing" :class="{ 'btn-ghost-secondary': !editing }" class="btn btn-sm btn-pill dropdown-toggle dropdown-toggle-split" id="dropdownMenuReference" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-reference="parent">
              <span class="sr-only">Toggle Dropdown</span><i class="fas fa-ellipsis-h"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuReference">
              <router-link
                  :to="'/mortgage-watch/' + item.uid + '/' + slug"
                  v-slot="{ navigate }">
                <a class="dropdown-item" href="#" @click="navigate">View latest deals</a>
              </router-link>
              <a class="dropdown-item" href="#" @click="editing = true">Edit</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="#" @click="confirmDelete = true">Delete</a>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <MortgageWizard v-if="editing" 
                        :wizard="item" allow-close
                        @completed="editCompleted($event)" 
                        @close="editing = false"></MortgageWizard>
        <div v-if="!editing" class="row">
          <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4">
            <router-link
                :to="'/mortgage-watch/' + item.uid + '/' + slug"
                v-slot="{ navigate }">
              <div class="card" @click="navigate" style="cursor: pointer">
                <div class="card-body bg-soft-navy align-items-center text-center">
                  <p class="card-text text-navy text-center" style="font-weight:bold; font-size: 5em; line-height: 1.2;">
                    {{ (item.mortgage.remainingBalance) | prettyMoneyThousands }}
                  </p>
                  <p class="card-text text-center">
                    Your remaining mortgage balance
                    <br>
                    <small style="font-weight: bold">Property value {{ item.mortgage.propertyValue | prettyMoney}} / LTV = {{ ltv | prettyPercent }}</small>
                  </p>
                </div>
                <div class="card-footer bg-soft-navy text-center border-top-0">
                  <button class="btn btn-sm btn-outline-navy w-100" @click.prevent="editing = true">Edit details</button>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4">
            <router-link
                :to="'/mortgage-watch/' + item.uid + '/' + slug"
                v-slot="{ navigate }">
              <div v-if="item.mortgage.DaysRemaining > 0" class="card" @click="navigate" style="cursor:pointer;;">
                <div class="card-body bg-soft-primary">
                  <p class="card-text text-center" :class="textClass" style="font-weight:bold; font-size: 5em; line-height: 1.2;">
                    {{ item.mortgage.DaysRemaining }}
                  </p>
                  <p class="card-text text-center">
                    Days until your current deal expires
                    <br>
                    <small style="font-weight: bold">Deal expires in {{ item.mortgage.endOfFixedTerm.toLocaleDateString('en-GB', { year: 'numeric', month: 'long' }) }}</small>
                  </p>
                </div>
                <div class="card-footer bg-soft-primary text-center border-top-0">
                  <button class="btn btn-sm btn-outline-primary w-100" @click="navigate">View latest deals</button>
                </div>
              </div>
            </router-link>
            <router-link
                :to="'/mortgage-watch/' + item.uid + '/' + slug"
                v-slot="{ navigate }">
              <div v-if="item.mortgage.DaysRemaining <= 0" class="card" @click="navigate" style="cursor: pointer">
                <div class="card-body bg-soft-primary">
                  <p class="card-text text-center" style="font-weight:bold; font-size: 5em; line-height: 1.2;">
                    <i class="fas fa-frown text-danger"></i>
                  </p>
                  <p class="card-text text-center">
                    Your fixed-term deal has expired
                    <br>
                    <small style="font-weight: bold">Deal expired on {{ item.mortgage.endOfFixedTerm.toLocaleDateString('en-GB', { year: 'numeric', month: 'long' }) }}</small>
                  </p>
                </div>
                <div class="card-footer bg-soft-primary text-center border-top-0">
                  <button class="btn btn-sm btn-outline-danger w-100" @click="navigate">View latest deals</button>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4">
            <div class="card bg-soft-success" @click="setStatus(!item.alerts.active)" style="cursor: pointer;">
              <div class="card-body">
                <p class="card-text text-center" style="font-size: 5em; line-height: 1.2;">
                  <i :class="{'fa-bell text-success': item.alerts.active, 'fa-bell text-secondary': !item.alerts.active}"
                     class="fas"></i>
                </p>
                <p class="card-text text-center">
                  Email Alerts are <strong style="text-transform: uppercase">{{ item.alerts.active ? "Enabled" : "Disabled" }}</strong>
                  <br>
                  <small style="font-weight: bold">Click to {{ item.alerts.active ? "disable" : "enable"}}</small>
                </p>
              </div>
              <div class="card-footer text-center border-top-0" style="background-color: rgba(0, 201, 167, 0.025);">
                <button class="btn btn-sm btn-outline-success w-100" @click.stop="openAlerts()">Configure alerts</button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!editing" class="row" title="card-deck card-sm-gutters-3 d-block d-sm-flex">
        </div>
        <div v-if="!editing && dealExpiringSoon" class="mmt-4 align-items-center alert alert-soft-danger media shadow-sm" role="alert">
          <i class="fas fa-exclamation-circle mmt-1 mr-4 fa-4x"></i>
          <div class="media-body" role="alert">
            <h3 class="alert-heading">
              <span v-if="item.mortgage.DaysRemaining > 0" >Your current fixed term deal is due to expire in {{ item.mortgage.DaysRemaining }} days.</span>
              <span v-if="item.mortgage.DaysRemaining <=0" >Your current fixed term deal has expired.</span>
              <br>
              <small>Act now to avoid over-paying on your mortgage.</small></h3>
          </div>
          <router-link
              :to="'/mortgage-watch/' + item.uid + '/' + slug"
              v-slot="{ navigate }">
            <button class="btn btn-danger btn-sm" @click="navigate">View deals!</button>
          </router-link>
        </div>
        <div v-if="false" class="card-columns" style="column-count: 2;">
          <div class="card bg-soft-primary">
            <div class="card-body">
              <h4 style="text-decoration: underline">Your Mortgage</h4>
              <div class="example-item">
                <div class="example-item-title">Property value:</div>
                <div class="example-item-value">{{ item.mortgage.propertyValue | prettyMoney }}</div>
              </div>
              <div class="example-item">
                <div class="example-item-title">Balance:</div>
                <div class="example-item-value">{{ item.mortgage.remainingBalance | prettyMoney }}</div>
              </div>
              <div class="example-item">
                <div class="example-item-title">Term:</div>
                <div class="example-item-value">{{ item.mortgage.term }} years</div>
              </div>
            </div>
          </div>
          <div class="card bg-soft-primary">
            <div class="card-body">
              <h4 style="text-decoration: underline">Your Lender</h4>
              <div class="example-item">
                <div class="example-item-title">Lender:</div>
                <div class="example-item-value">{{ getLender(item.mortgage.currentLender).lenderName }}</div>
              </div>
              <div class="example-item">
                <div class="example-item-title">Monthly:</div>
                <div class="example-item-value">{{ item.mortgage.currentMonthly | prettyMoney }}</div>
              </div>
              <div class="example-item">
                <div class="example-item-title">Deal ends:</div>
                <div class="example-item-value">{{ item.mortgage.endOfFixedTerm.toLocaleDateString() }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog :header="item.Description" :visible.sync="confirmDelete" :style="{width: '50vw'}" :modal="true">
      <p>
        Are you sure you want to delete this property?
        <br>
        <small>(this action cannot be undone!)</small>
      </p>
      <template #footer>
        <button class="btn btn-ghost-secondary" @click="confirmDelete = false">Cancel</button>
        <button class="btn btn-ghost-success" @click="deleteWatcher()" autofocus>OK</button>
      </template>
    </Dialog>
    <Dialog header="Configure Alert Frequency" :visible.sync="configureAlerts" :style="{width: '50vw'}" :modal="true">
      <ConfigureAlertsForm v-model="alerts"></ConfigureAlertsForm>
      <template #footer>
        <button class="btn btn-ghost-secondary" @click="configureAlerts = false">Cancel</button>
        <button class="btn btn-ghost-success" @click="updateAlerts()" autofocus>OK</button>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import dashify from "dashify"
import DaysRemainingButton from "@/components/dashboard/DaysRemainingButton";
import MortgageWizard from "@/components/MortgageWizard";
import Dialog from 'primevue/dialog';
import ConfigureAlertsForm from "@/components/dashboard/ConfigureAlertsForm";

export default {
  name: "MortgageWatchCard",
  
  components: {
    ConfigureAlertsForm,
    MortgageWizard,
    Dialog
  },
  
  props: {
    item: Object
  },
  
  data() {
    return {
      editing: false,
      configureAlerts: false,
      confirmDelete: false,
      alerts: {
        redFrequency: 0,
        amberFrequency: 0,
        greenFrequency: 0
      }
    }
  },
  
  computed: {
    ...mapGetters([
        "getLender",
        "isLoggedIn", "currentUser"
    ]),
    
    textClass() {
      return this.item.mortgage.DaysRemaining <= 30 ? "text-danger"
          : this.item.mortgage.DaysRemaining >= 90 ? "text-primary"
          : "text-warning";
    },

    buttonClass() {
      return this.item.mortgage.DaysRemaining <= 30 ? "btn-outline-danger" : "btn-outline-primary";
    },
    
    slug() {
      return dashify(this.item.Description, { condense: true});
    },
    
    dealExpiringSoon() {
      return this.item.mortgage.DaysRemaining < 30;
    },
    
    ltv() {
      return this.item.mortgage.remainingBalance / this.item.mortgage.propertyValue;
    }
  },
  
  methods: {
    ...mapActions([
        "deleteUserWatcher", "setUserWatcherStatus", "saveUserWatcher"
    ]),
    
    openAlerts() {
      this.alerts = { ...this.item.alerts };
      this.configureAlerts = true;
    },
    
    updateAlerts() {
      this.saveUserWatcher({
        owner: this.currentUser.email, 
        data: { ...this.item, alerts: { ...this.alerts, active: true } }
      });
      this.configureAlerts = false;
    },
    
    editCompleted(event) {
      this.saveUserWatcher({owner: this.currentUser.email, data: event});
      this.editing = false;
    },
    
    deleteWatcher() {
      this.deleteUserWatcher({
        owner: this.currentUser.email,
        id: this.item.uid
      });
    },
    
    setStatus(active) {
      this.setUserWatcherStatus({
        owner: this.currentUser.email,
        id: this.item.uid,
        active: active
      });
    }
    // getLender(lenderID) {
    //   return this.allLenders.find(item => item.lenderID === lenderID);
    //   // const tmp = this.allLenders.filter(item => item.lenderID === lenderID);
    //   // return tmp.length === 0 ? null : tmp[0];
    // }
  }
}
</script>

<style scoped>
.example-item {
  display: flex;
  padding-bottom: .2rem;
}
.example-item-title {
  flex: 0 0 140px;
}

.example-item-value {
  font-weight: bold;
  flex: 1 1 250px;
}
</style>